// extracted by mini-css-extract-plugin
export var hr_dark_bg = "HrHeading-module--hr_dark_bg--09e20";
export var hr_light_bg = "HrHeading-module--hr_light_bg--7dc36";
export var newH4 = "HrHeading-module--newH4--9de63";
export var row = "HrHeading-module--row--ee972";
export var text_dark = "HrHeading-module--text_dark--32e2d";
export var text_light = "HrHeading-module--text_light--1c223";